import { Flex } from "@chakra-ui/react";
import { WithAuth } from "@/hoc";
import { PixKeysComponent } from "./pixkeys";


const AccountDetail = () => {

    return (
        <Flex
            w="100%"
            flexDirection="column"
            gap="1rem"
        >

            <Flex
                flexDirection="column"
                maxW="1280px"
                w="100%"
                gap="1rem"
                py="4"
            >
                <PixKeysComponent />
            </Flex>
        </Flex>
    );
}

export default WithAuth(AccountDetail);
